"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmailIcon;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // Generated by build-icons
// Do not edit by hand!
// @hash c549d168642a323257dde8ab7e7b658b6874cef5
const svgElement = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M21 17h-4a.5.5 0 0 1 0-1h4c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5H3c-.827 0-1.5.673-1.5 1.5v11c0 .827.673 1.5 1.5 1.5h4a.5.5 0 0 1 0 1H3a2.503 2.503 0 0 1-2.5-2.5v-11C.5 2.122 1.621 1 3 1h18c1.379 0 2.5 1.122 2.5 2.5v11c0 1.378-1.121 2.5-2.5 2.5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 10.01a2.597 2.597 0 0 1-1.523-.493l-7.77-5.611a.5.5 0 0 1 .586-.811l7.77 5.611a1.58 1.58 0 0 0 1.875 0l7.77-5.611a.5.5 0 1 1 .586.81l-7.77 5.611c-.457.329-.99.494-1.524.494zM3 15a.5.5 0 0 1-.354-.853l5-5a.5.5 0 0 1 .707.707l-5 5A.498.498 0 0 1 3 15zM21 15a.502.502 0 0 1-.354-.146l-5-5a.5.5 0 0 1 .707-.707l5 5A.5.5 0 0 1 21 15z"
}), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M9 23H7a.5.5 0 0 1-.5-.5v-2c0-.133.053-.26.146-.354l8-8a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1 0 .707l-8 8A.496.496 0 0 1 9 23zm-1.5-1h1.293l7.5-7.5L15 13.207l-7.5 7.5V22z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M15 17a.502.502 0 0 1-.354-.146l-2-2a.5.5 0 0 1 .707-.707l2 2A.5.5 0 0 1 15 17z"
})));
function EmailIcon(props) {
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: "icon icon-email"
  }, props), svgElement);
}